import React, { useEffect, useState } from "react";
import { GetAllSubadminClient } from "../../CommonAPI/SubAdmin";
import FullDataTable from "../../../ExtraComponent/CommanDataTable";
import { useNavigate } from "react-router-dom";
import {
  GetGroupNames,
  EditClientPanle,
  Get_Broker_Name,
} from "../../CommonAPI/Admin";
import { Get_All_Plans } from "../../CommonAPI/User";

import { SquarePen } from "lucide-react";
import AddForm from "../../../ExtraComponent/FormData";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Content from "../../../ExtraComponent/Content";
import ReusableModal from "../../../ExtraComponent/ReusableModal";

const AllClient = () => {
  const userName = localStorage.getItem("name");
  const navigate = useNavigate();
  const [clientService, setClientService] = useState({
    loading: true,
    data: [],
  });
  const [searchInput, setSearchInput] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [optionsArray, setOptionsArray] = useState([]);
  const permission = localStorage.getItem("SubAdminPermission");
  const [brokerRecordData, setBrokerRecordData] = useState([]);
  const [showBrokerModal, setShowBrokerModal] = useState(false);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedClientForPlan, setSelectedClientForPlan] = useState(null);
  const [allPlans, setAllPlans] = useState({
    LivePlanName: [],
    DemoPlanName: [],
    data: [],
    SOPDEMO: [],
    SOPLive: [],
    ChartDEMO: [],
    ChartLive: [],
  });
  const [selectedBroker, setSelectedBroker] = useState("");

  useEffect(() => {
    fetchAllSubadmin();
  }, [searchInput]);

  useEffect(() => {
    fetchBrokerName();
    fetchGroupDetails();
    GetAllPlansData();
  }, []);

  const fetchAllSubadmin = async () => {
    const req = { userName: userName };
    try {
      const response = await GetAllSubadminClient(req);
      if (response.Status) {
        const filteredData = response.Data.filter((item) => {
          const searchInputMatch =
            searchInput === "" ||
            item.Username.toLowerCase().includes(searchInput.toLowerCase()) ||
            item.BrokerName.toLowerCase().includes(searchInput.toLowerCase()) ||
            item.EmailId.toLowerCase().includes(searchInput.toLowerCase()) ||
            item.Mobile_No.toLowerCase().includes(searchInput.toLowerCase());
          return searchInputMatch;
        });

        setClientService({
          loading: false,
          data: searchInput ? filteredData : response.Data,
        });
      } else {
        setClientService({ loading: false, data: [] });
      }
    } catch (error) {
      console.log("Error in fetching Subadmin", error);
    }
  };

  const fetchBrokerName = async () => {
    try {
      const response = await Get_Broker_Name();
      if (response.Status) {
        const brokerList = response?.brokers?.filter(
          (item) => item?.BrokerName !== "DEMO"
        );
        setBrokers(brokerList);
      } else {
        setBrokers([]);
      }
    } catch (error) {
      console.log("Error in fetching brokers", error);
    }
  };

  const fetchGroupDetails = async () => {
    try {
      const response = await GetGroupNames();
      if (response.Status) {
        const options = response.Data.map((item) => ({
          label: item.GroupName,
          value: item.GroupName,
        }));
        setOptionsArray(options);
      } else {
        setOptionsArray([]);
      }
    } catch (error) {
      console.log("Error in fetching group data", error);
    }
  };

  const EditSubadmindetail = (value, tableMeta) => {
    setSelectedIndex(clientService.data[tableMeta.rowIndex]);
    setShowModal(true);
  };

  const viewClient = permission.includes("ViewClient");
  const editClient = permission.includes("EditClient");
  const addClient = permission.includes("AddClient");

  const columns = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
      },
    },

    {
      name: "Username",
      label: "Username",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },

    {
      name: "BrokerName",
      label: "Broker Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "ActivePlan",
      label: "Plan Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          // Dropdown for plans (enabled, fixed width)
          const plans = Array.isArray(value) ? value : value ? [value] : [];
          return (
            <select
              style={{
                width: 160,
                minWidth: 160,
                maxWidth: 160,
                padding: "4px 8px",
                borderRadius: 4,
                background: "#fff",
                color: "#222",
                cursor: "pointer",
              }}
              defaultValue={plans[0] || ""}
              onClick={(e) => e.stopPropagation()} // Prevent row click
            >
              {plans.length > 0 ? (
                plans.map((plan, idx) => (
                  <option key={idx} value={plan}>
                    {plan}
                  </option>
                ))
              ) : (
                <option value="">-</option>
              )}
            </select>
          );
        },
      },
    },
    {
      name: "Clientammount",
      label: "Amount",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "0",
      },
    },
    {
      name: "CreateDate",
      label: "Account Create Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "ServiceStartDate",
      label: "Service Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "ServiceEndDate",
      label: "Service End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "ServiceCount",
      label: "Total Service Count",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "0",
      },
    },
    {
      name: "AssignPlan",
      label: "Assign Plan",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowData = clientService.data[tableMeta.rowIndex];
          const brokerName = rowData?.BrokerName;

          // If BrokerName is "DEMO", don't show the button
          // if (brokerName === "DEMO" || brokerName === "Demo") {
          //   return "-";
          // }

          return (
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => {
                setSelectedClientForPlan(rowData);
                setShowPlanModal(true);
              }}
              style={{ fontSize: "12px", padding: "4px 8px" }}
            >
              Assign Plan
            </button>
          );
        },
      },
    },
    {
      name: "Edit",
      label: "Edit",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          // Get BrokerName from the same row (column index 4)
          const brokerName = tableMeta.rowData[4];

          // If BrokerName is "DEMO", return empty or "-"
          if (brokerName === "DEMO" || brokerName === "Demo") {
            return "-";
          }

          // Otherwise, show the edit icon
          return (
            <SquarePen
              onClick={() => {
                if (editClient) {
                  EditSubadmindetail(value, tableMeta);
                } else {
                  Swal.fire("You don't have permission to edit!");
                }
              }}
              style={{ cursor: "pointer" }}
            />
          );
        },
      },
    },

    {
      name: "EmailId",
      label: "Email ID",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          if (!value) return "-";

          const [local, domain] = value.split("@");
          if (!local || !domain) return value; // invalid email fallback

          const visible = local.slice(0, 3); // first 3 letters
          return `${visible}***@${domain}`;
        },
      },
    },

    {
      name: "Mobile_No",
      label: "Mobile Number",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          if (!value) return "-";

          const strValue = value.toString();
          const last4 = strValue.slice(-4); // last 4 digits
          const masked = "*".repeat(strValue.length - 4); // rest masked
          return `${masked}${last4}`;
        },
      },
    },
  ];

  const formik = useFormik({
    initialValues: {
      User: "",
      Broker: "",
      GroupName: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.User && showModal) {
        errors.User = "Please enter the User";
      }
      if (!values.Broker && showModal) {
        errors.Broker = "Please Select the Broker";
      }
      return errors;
    },

    onSubmit: async (values) => {
      const req = {
        User: values.User,
        // GroupName: selectedOptions.map(item => item.value),
        Broker: values.Broker,
        SubAdmin: userName,
      };
      try {
        const response = await EditClientPanle(req);
        if (response.Status) {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Updated",
            text: response.message,
            icon: "success",
            timer: 1500,
            timerProgressBar: true,
          });
          setTimeout(() => {
            setShowModal(false);
            formik.resetForm();
            setSelectedOptions([]);
          }, 1500);
          fetchAllSubadmin();
        } else {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Error",
            text: response.message,
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
      } catch (err) {
        console.log("Error in update client", err);
      }
    },
  });

  // Formik for Plan Assignment Modal
  const planFormik = useFormik({
    initialValues: {
      selectedPlans: [],
      amount: "",
    },
    validate: (values) => {
      const errors = {};

      return errors;
    },
    onSubmit: async (values) => {
      console.log("Selected Client for Plan:", selectedClientForPlan);

      const req = {
        User: selectedClientForPlan?.Username,
        Broker: selectedBroker || selectedClientForPlan?.BrokerName,
        SubAdmin: userName,
      };

      if (values.amount > 0 && selectedBroker !== "DEMO") {
        req.Clientammount = values.amount;
      }
      if (values.selectedPlans.length > 0) {
        // remove existing plans from selectedPlans to avoid duplication
        const existingPlans = Array.isArray(selectedClientForPlan?.Planname)
          ? selectedClientForPlan.Planname
          : selectedClientForPlan?.Planname
          ? [selectedClientForPlan.Planname]
          : [];

        // Filter out existing plans from selectedPlans
        const newPlans = values.selectedPlans.filter(
          (plan) => !existingPlans.includes(plan)
        );
        console.log("New Plans to be added:", newPlans);
        req.SOPPlanname = newPlans?.length == 0 ? "" : newPlans[0];
      }

      try {
        const UpdateData = await EditClientPanle(req);

        if (UpdateData?.Status) {
          Swal.fire({
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Success",
            text: "Plan and amount updated successfully!",
            icon: "success",
            timer: 1500,
            timerProgressBar: true,
          });

          setTimeout(() => {
            setShowPlanModal(false);
            planFormik.resetForm();
            setSelectedClientForPlan(null);
          }, 1500);

          // Refresh the data
          fetchAllSubadmin();
        }
      } catch (err) {
        console.log("Error in updating plan", err);
        Swal.fire({
          backdrop: "#121010ba",
          confirmButtonColor: "#1ccc8a",
          title: "Error",
          text: "Failed to update plan and amount",
          icon: "error",
        });
      }
    },
  });

  const fields = [
    {
      name: "Broker",
      label: "Broker",
      type: "select",
      options:
        brokers &&
        brokers?.map((item) => ({
          label: item?.BrokerName,
          value: item?.BrokerName,
        })),
      label_size: 12,
      col_size: 12,
    },
  ];

  useEffect(() => {
    if (showModal) {
      formik.setFieldValue(
        "Broker",
        selectedIndex?.BrokerName == "Demo" ? "" : selectedIndex?.BrokerName
      );
      formik.setFieldValue("User", selectedIndex?.Username);
      setSelectedOptions(
        showModal &&
          selectedIndex?.Group.map((item) => ({ label: item, value: item }))
      );
    }
  }, [showModal]);

  // useEffect for Plan Assignment Modal
  useEffect(() => {
    if (showPlanModal && selectedClientForPlan) {
      // Set existing plans as selected (they will be shown in current plans section)
      const existingPlans = Array.isArray(selectedClientForPlan?.Planname)
        ? selectedClientForPlan.Planname
        : selectedClientForPlan?.Planname
        ? [selectedClientForPlan.Planname]
        : [];

      // Initialize with existing plans, but don't include them in the selectable plans
      planFormik.setFieldValue("selectedPlans", existingPlans);
    }
  }, [showPlanModal, selectedClientForPlan]);

  const GetAllPlansData = async () => {
    await Get_All_Plans()
      .then((response) => {
        if (response.Status) {
          const LivePlanName = [
            ...response.Admin.filter(
              (item) =>
                item.Planname !== "One Week Demo" &&
                item.Planname !== "Two Days Demo"
            ),
            ...response.Charting, // Charting array ko add kar diya
          ];

          const SOPPlans = LivePlanName.filter(
            (item) =>
              item.Planname !== "One Week Demo" &&
              item.Planname !== "Two Days Demo" &&
              item.ChartingSignal.length === 0
          );
          const ChartPlans = LivePlanName.filter(
            (item) =>
              item.Planname !== "One Week Demo" &&
              item.Planname !== "Two Days Demo" &&
              item.ChartingSignal.length !== 0
          );

          const DemoPlanName = response.Admin.filter(
            (item) =>
              item.Planname === "One Week Demo" ||
              item.Planname === "Two Days Demo"
          );

          const sopDemo = response.Admin.filter(
            (item) => item.PlanType === "Demo"
          );
          let sopLive = response.Admin.filter(
            (item) => item.PlanType === "Live"
          );
          sopLive = sopLive.map((plan) => {
            return {
              ...plan,
              price: plan.SOPPrice,
            };
          });
          const chartDemo = response.Charting.filter(
            (item) => item.PlanType === "Demo"
          );
          let chartLive = response.Charting.filter(
            (item) => item.PlanType === "Live"
          );
          chartLive = chartLive.map((plan) => {
            return {
              ...plan,
              price: plan.ChartPerMonth,
            };
          });

          const OverallDataDemo = response.OverallData.filter(
            (item) => item.PlanType === "Demo"
          );
          let OverallDataLive = response.OverallData.filter(
            (item) => item.PlanType === "Live"
          );
          OverallDataLive = OverallDataLive.map((plan) => {
            return {
              ...plan,
              price: plan.OverallPrice,
            };
          });

          setAllPlans({
            demo: [...sopDemo, ...chartDemo, ...OverallDataDemo],
            live: [...sopLive, ...chartLive, ...OverallDataLive],
          });
        } else {
          setAllPlans({ DemoPlanName: [], LivePlanName: [], data: [] });
        }
      })
      .catch((err) => {
        console.log("Error in fetching the plans", err);
      });
  };

  useEffect(() => {
    if(selectedBroker === "DEMO") {
      planFormik.setFieldValue("amount", "0");
    }
  }, [selectedBroker]);

  return (
    <>
      <Content
        Page_title={"Clients"}
        button_status={true}
        backbutton_status={true}
        route={"/subadmin/addclient"}
        button_title={"Add Client"}
      >
            <nav aria-label="breadcrumb">
      <ol className="breadcrumb d-block d-sm-flex justify-content-between align-items-center">
        <li className="breadcrumb-item active " aria-current="page">
        Clients
        </li>
{/* ➕ Add Client Button on Right */}
            {addClient && (
              <div className="col-lg-3 col-md-4 text-end">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    if (permission.includes("AddClient")) {
                      navigate("/subadmin/addclient");
                    } else {
                      Swal.fire("You don't have permission to add a client!");
                    }
                  }}
                >
                  Add Client
                </button>
              </div>
            )}
          </ol>
        </nav>
        <div className="iq-card-body">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            {/* 🔍 Search on Left */}
            <div className="col-lg-3 col-md-4 mb-2 mb-md-0">
              <input
                type="text"
                className="form-control rounded p-1 px-2"
                placeholder="Search..."
                onChange={(e) => setSearchInput(e.target.value)}
                value={searchInput}
              />
            </div>
          </div>

          {clientService.data && clientService.data.length > 0 ? (
            <FullDataTable
              columns={columns}
              data={clientService.data}
              checkBox={false}
            />
          ) : (
            <NoDataFound />
          )}
        </div>

        {showModal && (
          <div
            className="modal custom-modal d-flex"
            id="add_vendor"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header clientheader border-0 pb-0">
                  <div className="form-header modal-header-title text-start mb-0">
                    <h4 className="mb-0">
                      Edit Client : {selectedIndex?.Username}
                    </h4>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setShowModal(false);
                      formik.resetForm();
                      setSelectedOptions([]);
                    }}
                  ></button>
                </div>
                <hr />
                <AddForm
                  fields={fields.filter(
                    (field) => !field.showWhen || field.showWhen(formik.values)
                  )}
                  btn_name="Update"
                  formik={formik}
                  btn_name1_route="/admin/clientservice"
                />
              </div>
            </div>
          </div>
        )}

        <ReusableModal
          show={showPlanModal}
          onClose={() => {
            setShowPlanModal(false);
            setSelectedClientForPlan(null);
            planFormik.resetForm();
          }}
          title={`Assign Plan & Amount - ${
            selectedClientForPlan?.Username || "Unknown"
          }`}
          size="xl"
          body={
            <form onSubmit={planFormik.handleSubmit}>
              <div className="row mb-4">
                <div className="col-md-6">
                  <h6 className="text-primary mb-2">Current Information</h6>
                  <div className="card p-3 bg-light">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                      <p className="mb-0">
                        <strong>Username:</strong>{" "}
                        {selectedClientForPlan?.Username || "-"}
                      </p>
                      <p className="mb-0">
                        <strong>Current Amount:</strong> ₹
                        {selectedClientForPlan?.Clientammount || "0"}
                      </p>
                      <p className="mb-0">
                        <strong>Current Plans:</strong>{" "}
                        {Array.isArray(selectedClientForPlan?.Planname)
                          ? selectedClientForPlan.Planname.join(", ")
                          : selectedClientForPlan?.Planname || "None"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Broker Asgin  */}
                <div className="col-lg-6 mb-3">
                  <label className="form-label card-text-Color">
                    <strong>Broker </strong>
                  </label>
                  <select
                    className="form-select"
                    name="Broker"
                    value={selectedBroker}
                    onChange={(e) => setSelectedBroker(e.target.value)}
                  >
                    {selectedClientForPlan?.BrokerName == "DEMO" && (
                      <option value="DEMO">DEMO</option>
                    )}
                    {brokers.map((broker) => (
                      <option key={broker.BrokerName} value={broker.BrokerName}>
                        {broker.BrokerName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-lg-6 mb-3">
                  <label className="form-label card-text-Color">
                    <strong>Amount (₹)</strong>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    value={planFormik.values.amount}
                    onChange={planFormik.handleChange}
                    onBlur={planFormik.handleBlur}
                    placeholder="Enter amount"
                    min="0"
                    step="0.01"
                    disabled={selectedBroker === "DEMO"}
                  />
                  {planFormik.errors.amount && (
                    <div className="text-danger small mt-1">
                      {planFormik.errors.amount}
                    </div>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <div className="mb-3">
                  <h6 className="text-primary mb-2">
                    <i className="fas fa-plus-circle me-1"></i>
                    Available Plans (Select additional plans)
                  </h6>
                  <div className="row">
                    {allPlans?.live?.length > 0 ? (
                      allPlans.live.map((plan, index) => {
                        const isCurrentPlan =
                          selectedClientForPlan?.Planname &&
                          (Array.isArray(selectedClientForPlan.Planname)
                            ? selectedClientForPlan.Planname.includes(
                                plan.Planname
                              )
                            : selectedClientForPlan.Planname === plan.Planname);

                        if (isCurrentPlan) return null;

                        return (
                          <div key={plan.id || index} className="col-md-3 mb-3">
                            <div className="card p-3 border h-100">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`plan-${plan.id || index}`}
                                  value={plan.Planname}
                                  checked={planFormik.values.selectedPlans.includes(
                                    plan.Planname
                                  )}
                                  disabled={
                                    selectedClientForPlan?.Clientammount <
                                    plan.SOPPrice +
                                      plan.ChartPerMonth +
                                      plan.OverallPrice
                                  }
                                  onChange={(e) => {
                                    const newPlans = e.target.checked
                                      ? [plan.Planname]
                                      : planFormik.values.selectedPlans.filter(
                                          (planName) =>
                                            planName !== plan.Planname
                                        );

                                    planFormik.setFieldValue(
                                      "selectedPlans",
                                      newPlans
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label w-100"
                                  htmlFor={`plan-${plan.id || index}`}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                      <h6 className="mb-1 text-dark">
                                        {plan.Planname}
                                      </h6>
                                      <small className="text-muted">
                                        {plan.PlanType === "Live"
                                          ? "Live Plan"
                                          : "Demo Plan"}
                                      </small>
                                    </div>
                                    <div className="text-end">
                                      {plan.price > 0 && (
                                        <div className="text-warning fw-bold">
                                          ₹{plan.price}
                                        </div>
                                      )}

                                      {!plan.price && (
                                        <div className="text-muted">
                                          Free Plan
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </label>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-12">
                        <div className="alert alert-warning text-center">
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          No live plans available at the moment
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {planFormik.errors.selectedPlans && (
                  <div className="text-danger small mt-1">
                    {planFormik.errors.selectedPlans}
                  </div>
                )}
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowPlanModal(false);
                    setSelectedClientForPlan(null);
                    planFormik.resetForm();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={planFormik.isSubmitting}
                >
                  {planFormik.isSubmitting
                    ? "Updating..."
                    : "Update Plan & Amount"}
                </button>
              </div>
            </form>
          }
        />
      </Content>
    </>
  );
};

export default AllClient;
